import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=64964edb&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=64964edb&prod&scoped=true&lang=css"
import style1 from "./HomeLayout.vue?vue&type=style&index=1&id=64964edb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64964edb",
  null
  
)

export default component.exports